import TransitionWrapper from "../common/transition-wrapper";
import ReactLoadingSkeleton from "react-loading-skeleton";
import ResponsiveCDNImage from "../common/image/responsive-cdn-image";
import { useState } from "react";

interface IProp {
  onClick: () => void;
  title: string;
  discountPrice: number;
  price: number;
  img: string;
  address: string;
}

/**
 * 웰컴 페이지에 렌더링되는 매장 카드
 * 매장 이름, 주소, 팩 가격 위주로 렌더링
 */
export const StoreCardForWelcome = ({
  onClick,
  title,
  discountPrice,
  price,
  img,
  address,
}: IProp): JSX.Element => {
  const [isImageLoading, setIsImageLoading] = useState(true);

  return (
    <>
      <TransitionWrapper
        scale={0.9}
        opacity={0.9}
        className="w-full h-56"
        onClick={onClick}
      >
        <div className="w-full h-full">
          <div className="relative w-full h-full bg-white rounded-[12px] overflow-hidden shadow-lg">
            {/* Upper Box */}
            <div className="absolute w-full h-[8rem]">
              <div className="relative w-full h-full">
                {isImageLoading && (
                  <div className={`w-full h-full absolute left-0`}>
                    {/* align-top으로 단차를 없앱니다 */}
                    <ReactLoadingSkeleton className="w-full h-full align-top" />
                  </div>
                )}

                {/* 실제 이미지들 */}
                <div className="w-full h-full flex gap-2">
                  <div className="h-full overflow-hidden w-full rounded-lg">
                    <ResponsiveCDNImage
                      src={img}
                      alt={title}
                      className="w-full h-full object-cover"
                      onLoad={() => setIsImageLoading(false)}
                      lazy={true}
                      rootMargin="300px"
                    />
                  </div>
                </div>

                {/* Add a gradient overlay */}
                <div className="absolute bottom-0 left-0 w-full h-full bg-gradient-to-t from-black to-transparent opacity-30"></div>
              </div>
              <div className="flex gap-2">
                <div className="absolute bottom-2 left-4 right-4 flex items-center font-bold text-white text-xl">
                  <div className="flex items-center gap-2 min-w-0 max-w-full">
                    <span className="text-white truncate">{title}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Lower Box */}
            <div className="absolute w-full bottom-6 left-0 px-4 flex justify-between">
              {/* Left Box */}
              <div className="flex flex-col items-start justify-start min-w-0 flex-1 pr-4 h-full">
                <div className="flex gap-1 items-end font-semibold text-black text-lg mb-1 w-full">
                  <span className="truncate">{title} 마히팩</span>
                </div>

                <span className="text-base text-gray-500">{address}</span>
              </div>

              {/* Right Box */}
              <div className="flex flex-col items-end justify-center flex-shrink-0">
                <p className="font-bold text-gray-400 text-md line-through">
                  {price ? `${price?.toLocaleString()}원` : null}
                </p>
                <p className="font-bold text-green-600 text-2xl ml-4">
                  {discountPrice
                    ? `${discountPrice?.toLocaleString()}원`
                    : null}
                </p>
              </div>
            </div>
          </div>
        </div>
      </TransitionWrapper>
    </>
  );
};
